import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { getTwilioCustomerProfile } from 'api/admin/businesses/twilioIntegration';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';
import { TwilioCustomerProfileHttpResponse } from 'types/twilio/twilioCustomerProfile';

export const useGetTwilioCustomerProfile = (
  businessId: number,
  customerProfileId: string | null | undefined,
) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    TwilioCustomerProfileHttpResponse
  >({
    queryKey: [TwilioQueryKeys.CUSTOMER_PROFILE, businessId],
    queryFn: async () => {
      const response = await getTwilioCustomerProfile(businessId);

      return response.data;
    },
    enabled: !!customerProfileId,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching Twilio customer profile',
        {
          icon: '❌',
        },
      );
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
